module.exports = {
	"config": {
		"blogTitle": "Harrison & India",
		"authorName": "Harrison Thirkettle",
		"linkPrefix": ""
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "",
				"stem": "_template",
				"path": "_template.js"
			},
			"requirePath": "_template.js",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-03-harrison-excited",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "2017-04-03-harrison-excited",
				"stem": "index",
				"path": "2017-04-03-harrison-excited/index.js"
			},
			"requirePath": "2017-04-03-harrison-excited/index.js",
			"path": "/excited/",
			"data": {
				"title": "Excited about India",
				"date": "2017-04-03T18:49:00.000+01:00",
				"path": "/excited/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-04-harrison-first-day-in-india",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "2017-04-04-harrison-first-day-in-india",
				"stem": "index",
				"path": "2017-04-04-harrison-first-day-in-india/index.js"
			},
			"requirePath": "2017-04-04-harrison-first-day-in-india/index.js",
			"path": "/first-day-in-india/",
			"data": {
				"title": "My first day in India",
				"date": "2017-04-04T20:30:00+05:30",
				"path": "/first-day-in-india/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-05-harrison",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-04-05-harrison",
				"stem": "index",
				"path": "2017-04-05-harrison/index.md"
			},
			"requirePath": "2017-04-05-harrison/index.md",
			"path": "/2017-04-05-kattoor/",
			"data": {
				"title": "Today we went to the sunny beach",
				"date": "2017-04-05T20:00:00+05:30",
				"path": "/2017-04-05-kattoor/",
				"author": "HARRISON"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-06-harrison",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "2017-04-06-harrison",
				"stem": "index",
				"path": "2017-04-06-harrison/index.js"
			},
			"requirePath": "2017-04-06-harrison/index.js",
			"path": "/2017-04-06-kattoor/",
			"data": {
				"title": "Felt ill but got better!",
				"date": "2017-04-06T20:30:00+05:30",
				"path": "/2017-04-06-kattoor/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-07-harrison-story",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-04-07-harrison-story",
				"stem": "index",
				"path": "2017-04-07-harrison-story/index.md"
			},
			"requirePath": "2017-04-07-harrison-story/index.md",
			"path": "/2017-04-07-alien-story/",
			"data": {
				"title": "Harrison's Alien story",
				"date": "2017-04-07T10:00:00+05:30",
				"path": "/2017-04-07-alien-story/",
				"author": "HARRISON"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-07-harrison",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-04-07-harrison",
				"stem": "index",
				"path": "2017-04-07-harrison/index.md"
			},
			"requirePath": "2017-04-07-harrison/index.md",
			"path": "/2017-04-07-kattoor/",
			"data": {
				"title": "Found a swimming pool",
				"date": "2017-04-07T20:30:00+05:30",
				"path": "/2017-04-07-kattoor/",
				"author": "HARRISON"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-08-harrison-allepey",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "2017-04-08-harrison-allepey",
				"stem": "index",
				"path": "2017-04-08-harrison-allepey/index.js"
			},
			"requirePath": "2017-04-08-harrison-allepey/index.js",
			"path": "/2017-04-08-alleppey/",
			"data": {
				"title": "The backwaters of Alleppey",
				"date": "2017-04-08T20:30:00+05:30",
				"path": "/2017-04-08-alleppey/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-08-harrison-yoga",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "2017-04-08-harrison-yoga",
				"stem": "index",
				"path": "2017-04-08-harrison-yoga/index.js"
			},
			"requirePath": "2017-04-08-harrison-yoga/index.js",
			"path": "/2017-04-08-yoga-and-kalaripayattu/",
			"data": {
				"title": "Yoga and Kalaripayattu with Aki",
				"date": "2017-04-08T10:30:00+05:30",
				"path": "/2017-04-08-yoga-and-kalaripayattu/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-09-harrison",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-04-09-harrison",
				"stem": "index",
				"path": "2017-04-09-harrison/index.md"
			},
			"requirePath": "2017-04-09-harrison/index.md",
			"path": "/2017-04-09-kerala-to-goa/",
			"data": {
				"title": "Leaving Kerala on the sleeper train",
				"date": "2017-04-09T21:00:00+05:30",
				"path": "/2017-04-09-kerala-to-goa/",
				"author": "HARRISON"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-10-harrison",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "2017-04-10-harrison",
				"stem": "index",
				"path": "2017-04-10-harrison/index.js"
			},
			"requirePath": "2017-04-10-harrison/index.js",
			"path": "/2017-04-10-train-to-madgoan/",
			"data": {
				"title": "One day in Goa",
				"date": "2017-04-10T09:30:00+05:30",
				"path": "/2017-04-10-train-to-madgoan/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-11-harrison",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "2017-04-11-harrison",
				"stem": "index",
				"path": "2017-04-11-harrison/index.js"
			},
			"requirePath": "2017-04-11-harrison/index.js",
			"path": "/2017-04-11-train-to-madgoan/",
			"data": {
				"title": "Train to Hampi",
				"date": "2017-04-11T21:00:00+05:30",
				"path": "/2017-04-11-train-to-madgoan/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-12-harrison",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "2017-04-12-harrison",
				"stem": "index",
				"path": "2017-04-12-harrison/index.js"
			},
			"requirePath": "2017-04-12-harrison/index.js",
			"path": "/2017-04-12-hampi-and-the-missing-tooth/",
			"data": {
				"title": "Losing my first tooth in Hampi",
				"date": "2017-04-12T21:00:00+05:30",
				"path": "/2017-04-12-hampi-and-the-missing-tooth/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-13-harrison",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "2017-04-13-harrison",
				"stem": "index",
				"path": "2017-04-13-harrison/index.js"
			},
			"requirePath": "2017-04-13-harrison/index.js",
			"path": "/2017-04-13-hampi-temples/",
			"data": {
				"title": "Visiting the temples of Hampi",
				"date": "2017-04-13T21:00:00+05:30",
				"path": "/2017-04-13-hampi-temples/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-14-harrison",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "2017-04-14-harrison",
				"stem": "index",
				"path": "2017-04-14-harrison/index.js"
			},
			"requirePath": "2017-04-14-harrison/index.js",
			"path": "/bye-hampi-hello-mumbai/",
			"data": {
				"title": "Goodbye Hampi - hello Mumbai",
				"date": "2017-04-14T20:30:00+05:30",
				"path": "/bye-hampi-hello-mumbai/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-15-harrison",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-04-15-harrison",
				"stem": "index",
				"path": "2017-04-15-harrison/index.md"
			},
			"requirePath": "2017-04-15-harrison/index.md",
			"path": "/2017-04-15-waking-in-mumbai/",
			"data": {
				"title": "Waking up in Bombay",
				"date": "2017-04-15T20:00:00+05:30",
				"path": "/2017-04-15-waking-in-mumbai/",
				"author": "HARRISON"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-16-harrison",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "2017-04-16-harrison",
				"stem": "index",
				"path": "2017-04-16-harrison/index.js"
			},
			"requirePath": "2017-04-16-harrison/index.js",
			"path": "/bombay-tour-and-zoo/",
			"data": {
				"title": "A tour and the zoo in Bombay",
				"date": "2017-04-16T20:30:00+05:30",
				"path": "/bombay-tour-and-zoo/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-17-harrison",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "2017-04-17-harrison",
				"stem": "index",
				"path": "2017-04-17-harrison/index.js"
			},
			"requirePath": "2017-04-17-harrison/index.js",
			"path": "/oompa-loompa-football-in-bombay/",
			"data": {
				"title": "Oompa loompa football and leaving Bombay",
				"date": "2017-04-17T20:30:00+05:30",
				"path": "/oompa-loompa-football-in-bombay/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-18-harrison",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "2017-04-18-harrison",
				"stem": "index",
				"path": "2017-04-18-harrison/index.js"
			},
			"requirePath": "2017-04-18-harrison/index.js",
			"path": "/ranthambore-national-park/",
			"data": {
				"title": "Ranthambore National Park",
				"date": "2017-04-18T20:30:00+05:30",
				"path": "/ranthambore-national-park/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-19-harrison",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "2017-04-19-harrison",
				"stem": "index",
				"path": "2017-04-19-harrison/index.js"
			},
			"requirePath": "2017-04-19-harrison/index.js",
			"path": "/we-saw-a-wild-tiger-at-ranthambore/",
			"data": {
				"title": "We saw a wild tiger!",
				"date": "2017-04-19T20:30:00+05:30",
				"path": "/we-saw-a-wild-tiger-at-ranthambore/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-20-harrison",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-04-20-harrison",
				"stem": "index",
				"path": "2017-04-20-harrison/index.md"
			},
			"requirePath": "2017-04-20-harrison/index.md",
			"path": "/2017-04-20-udaipur-first-day/",
			"data": {
				"title": "First day in Udaipur",
				"date": "2017-04-20T20:30:00+05:30",
				"path": "/2017-04-20-udaipur-first-day/",
				"author": "HARRISON"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-21-harrison",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "2017-04-21-harrison",
				"stem": "index",
				"path": "2017-04-21-harrison/index.js"
			},
			"requirePath": "2017-04-21-harrison/index.js",
			"path": "/2017-04-21-art-with-locky/",
			"data": {
				"title": "Art class with Locky",
				"date": "2017-04-21T20:30:00+05:30",
				"path": "/2017-04-21-art-with-locky/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-22-harrison",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "2017-04-22-harrison",
				"stem": "index",
				"path": "2017-04-22-harrison/index.js"
			},
			"requirePath": "2017-04-22-harrison/index.js",
			"path": "/cooking-with-locky-udaipur/",
			"data": {
				"title": "Cooking class in Udaipur",
				"date": "2017-04-22T20:30:00+05:30",
				"path": "/cooking-with-locky-udaipur/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-23-harrison",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-04-23-harrison",
				"stem": "index",
				"path": "2017-04-23-harrison/index.md"
			},
			"requirePath": "2017-04-23-harrison/index.md",
			"path": "/2017-04-23-the-farm-jaipur/",
			"data": {
				"title": "The Farm - Jaipur",
				"date": "2017-04-23T20:30:00+05:30",
				"path": "/2017-04-23-the-farm-jaipur/",
				"author": "HARRISON"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-24-harrison",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "2017-04-24-harrison",
				"stem": "index",
				"path": "2017-04-24-harrison/index.js"
			},
			"requirePath": "2017-04-24-harrison/index.js",
			"path": "/elephantastic-jaipur/",
			"data": {
				"title": "Elephantastic - Jaipur",
				"date": "2017-04-24T20:30:00+05:30",
				"path": "/elephantastic-jaipur/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-25-harrison",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "2017-04-25-harrison",
				"stem": "index",
				"path": "2017-04-25-harrison/index.js"
			},
			"requirePath": "2017-04-25-harrison/index.js",
			"path": "/yoga-the-farm-jaipur/",
			"data": {
				"title": "The day when we did yoga",
				"date": "2017-04-25T20:30:00+05:30",
				"path": "/yoga-the-farm-jaipur/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-26-harrison",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "2017-04-26-harrison",
				"stem": "index",
				"path": "2017-04-26-harrison/index.js"
			},
			"requirePath": "2017-04-26-harrison/index.js",
			"path": "/taj-mahal-agra/",
			"data": {
				"title": "The Taj Mahal trip",
				"date": "2017-04-26T20:30:00+05:30",
				"path": "/taj-mahal-agra/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-27-harrison",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-04-27-harrison",
				"stem": "index",
				"path": "2017-04-27-harrison/index.md"
			},
			"requirePath": "2017-04-27-harrison/index.md",
			"path": "/2017-04-27-the-farm-jaipur/",
			"data": {
				"title": "Lazy day at The Farm - Jaipur",
				"date": "2017-04-27T20:30:00+05:30",
				"path": "/2017-04-27-the-farm-jaipur/",
				"author": "HARRISON"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-28-harrison",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "2017-04-28-harrison",
				"stem": "index",
				"path": "2017-04-28-harrison/index.js"
			},
			"requirePath": "2017-04-28-harrison/index.js",
			"path": "/jaipur-forts/",
			"data": {
				"title": "Jaipur - visiting the forts",
				"date": "2017-04-28T20:30:00+05:30",
				"path": "/jaipur-forts/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-29-harrison",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-04-29-harrison",
				"stem": "index",
				"path": "2017-04-29-harrison/index.md"
			},
			"requirePath": "2017-04-29-harrison/index.md",
			"path": "/2017-04-29-jaisalmer-desert-safari/",
			"data": {
				"title": "Sleeping in the desert near Jaisalmer",
				"date": "2017-04-29T20:30:00+05:30",
				"path": "/2017-04-29-jaisalmer-desert-safari/",
				"author": "HARRISON"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-04-30-harrison",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-04-30-harrison",
				"stem": "index",
				"path": "2017-04-30-harrison/index.md"
			},
			"requirePath": "2017-04-30-harrison/index.md",
			"path": "/2017-04-30-jaisalmer-desert-safari-again/",
			"data": {
				"title": "Dancing and sleeping in the desert",
				"date": "2017-04-30T20:30:00+05:30",
				"path": "/2017-04-30-jaisalmer-desert-safari-again/",
				"author": "HARRISON"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-05-01-03-harrison",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-05-01-03-harrison",
				"stem": "index",
				"path": "2017-05-01-03-harrison/index.md"
			},
			"requirePath": "2017-05-01-03-harrison/index.md",
			"path": "/2017-05-03-jaisalmer-delhi-kalka/",
			"data": {
				"title": "Mainly travelling",
				"date": "2017-05-03T10:00:00+05:30",
				"path": "/2017-05-03-jaisalmer-delhi-kalka/",
				"author": "HARRISON"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-05-04-harrison",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-05-04-harrison",
				"stem": "index",
				"path": "2017-05-04-harrison/index.md"
			},
			"requirePath": "2017-05-04-harrison/index.md",
			"path": "/2017-05-04-shimla/",
			"data": {
				"title": "The Toy train to Shimla",
				"date": "2017-05-04T20:30:00+05:30",
				"path": "/2017-05-04-shimla/",
				"author": "HARRISON"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-05-05-harrison",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "2017-05-05-harrison",
				"stem": "index",
				"path": "2017-05-05-harrison/index.js"
			},
			"requirePath": "2017-05-05-harrison/index.js",
			"path": "/2017-05-05-shimla/",
			"data": {
				"title": "Monkeying around in Shimla",
				"date": "2017-05-05T20:30:00+05:30",
				"path": "/2017-05-05-shimla/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-05-08-harrison",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-05-08-harrison",
				"stem": "index",
				"path": "2017-05-08-harrison/index.md"
			},
			"requirePath": "2017-05-08-harrison/index.md",
			"path": "/2017-05-08-shimla/",
			"data": {
				"title": "Leopards and leaving Shimla",
				"date": "2017-05-08T20:30:00+05:30",
				"path": "/2017-05-08-shimla/",
				"author": "HARRISON"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-05-09-harrison",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-05-09-harrison",
				"stem": "index",
				"path": "2017-05-09-harrison/index.md"
			},
			"requirePath": "2017-05-09-harrison/index.md",
			"path": "/2017-05-09-patna/",
			"data": {
				"title": "Welcome to Patna",
				"date": "2017-05-09T20:30:00+05:30",
				"path": "/2017-05-09-patna/",
				"author": "HARRISON"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-05-10-harrison",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-05-10-harrison",
				"stem": "index",
				"path": "2017-05-10-harrison/index.md"
			},
			"requirePath": "2017-05-10-harrison/index.md",
			"path": "/2017-05-10-patna/",
			"data": {
				"title": "Meeting Sandeep",
				"date": "2017-05-10T20:30:00+05:30",
				"path": "/2017-05-10-patna/",
				"author": "HARRISON"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-05-11-vicky",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-05-11-vicky",
				"stem": "index",
				"path": "2017-05-11-vicky/index.md"
			},
			"requirePath": "2017-05-11-vicky/index.md",
			"path": "/2017-05-11-patna/",
			"data": {
				"title": "Mummy's day with World Vision",
				"date": "2017-05-11T20:30:00+05:30",
				"path": "/2017-05-11-patna/",
				"author": "VICKY"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-05-12-photos",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-05-12-photos",
				"stem": "index",
				"path": "2017-05-12-photos/index.md"
			},
			"requirePath": "2017-05-12-photos/index.md",
			"path": "/2017-05-12-varanasi-train/",
			"data": {
				"title": "Train to Varanasi",
				"date": "2017-05-12T20:30:00+05:30",
				"path": "/2017-05-12-varanasi-train/",
				"author": "HARRISON"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-05-13-harrison",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-05-13-harrison",
				"stem": "index",
				"path": "2017-05-13-harrison/index.md"
			},
			"requirePath": "2017-05-13-harrison/index.md",
			"path": "/2017-05-13-varanasi/",
			"data": {
				"title": "Exploring Varanasi",
				"date": "2017-05-13T20:30:00+05:30",
				"path": "/2017-05-13-varanasi/",
				"author": "HARRISON"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-05-14-photos",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-05-14-photos",
				"stem": "index",
				"path": "2017-05-14-photos/index.md"
			},
			"requirePath": "2017-05-14-photos/index.md",
			"path": "/2017-05-14-varanasi/",
			"data": {
				"title": "Pillow fight!",
				"date": "2017-05-14T20:30:00+05:30",
				"path": "/2017-05-14-varanasi/",
				"author": "HARRISON"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-05-19-harrison",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-05-19-harrison",
				"stem": "index",
				"path": "2017-05-19-harrison/index.md"
			},
			"requirePath": "2017-05-19-harrison/index.md",
			"path": "/2017-05-19-palolem-goa/",
			"data": {
				"title": "Palolem beach - Goa",
				"date": "2017-05-19T20:30:00+05:30",
				"path": "/2017-05-19-palolem-goa/",
				"author": "HARRISON"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-06-04-harrison",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-06-04-harrison",
				"stem": "index",
				"path": "2017-06-04-harrison/index.md"
			},
			"requirePath": "2017-06-04-harrison/index.md",
			"path": "/2017-06-04/interview/",
			"data": {
				"title": "A final interview",
				"date": "2017-06-04T19:00:00.000+01:00",
				"path": "/2017-06-04/interview/",
				"author": "HARRISON"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js"
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 381
// module chunks = 0